// src/components/AboutUs.js
import React from 'react';
import { Link } from 'react-router-dom'; // Use Link for client-side navigation
import cfirPhoto from '../Cfir_image_linkedin.png';  // Updated path
import omerPhoto from '../Omer_Ben_simon_photo_WizeAssist.jpg';  // Updated path
import logo from '../WizeAssist_white_logo.png'; // Updated path
import 'bootstrap/dist/css/bootstrap.min.css';
import '../styles/App.css'; // Import the consolidated App.css

function AboutUs() {
  return (
    <main className="page-wrap">
      {/* Hero-like Banner */}
      <section className="hero-section text-center py-5 mb-5">
        <img src={logo} alt="WizeAssist Logo" className="hero-logo mb-4" style={{ width: '150px' }} />
        <h1 className="display-4 text-pink">Our Story</h1>
        <p className="lead text-white" style={{ maxWidth: '700px', margin: '0 auto' }}>
          WizeAssist was founded with a vision to revolutionize sports training through cutting-edge technology. 
          Born from the combined passion for sports, AI, minimizing injury risks, and data-driven insights, our journey began with a simple 
          idea: empower athletes and coaches with tools that enhance performance, prevent injuries, and foster 
          continuous improvement.
        </p>
      </section>

      {/* Founders Section */}
      <section className="founders-section mb-5">
        <h2 className="text-teal text-center mb-4">Meet Our Founders</h2>
        <div className="container">
          <div className="row justify-content-center">
            {/* Cfir Croitoru */}
            <div className="col-md-6 col-lg-4 mb-4">
              <div className="founder-card glass p-4 h-100 text-center">
                <img 
                  src={cfirPhoto} 
                  alt="Cfir Croitoru" 
                  className="founder-photo mb-3 rounded-circle shadow"
                  style={{ width: '150px', height: '150px', objectFit: 'cover' }}
                />
                <h3 className="text-purple">Cfir Croitoru</h3>
                <h4 className="text-accent">Co-Founder & CEO</h4>
                <p className="text-gray-light">
                  Driven by a deep love for innovation and sports performance, Cfir leads WizeAssist’s strategic vision. 
                  With a background in Computer science and business leadership, he’s dedicated to creating tools that help teams 
                  train smarter, recover faster, and unlock new potential.
                </p>
              </div>
            </div>

            {/* Omer Ben Simon */}
            <div className="col-md-6 col-lg-4 mb-4">
              <div className="founder-card glass p-4 h-100 text-center">
                <img 
                  src={omerPhoto} 
                  alt="Omer Ben Simon" 
                  className="founder-photo mb-3 rounded-circle shadow"
                  style={{ width: '150px', height: '150px', objectFit: 'cover' }}
                />
                <h3 className="text-purple">Omer Ben Simon</h3>
                <h4 className="text-accent">Co-Founder & CTO</h4>
                <p className="text-gray-light">
                  Omer with a passion for cutting-edge technologies in sports science. 
                  He’s the technical architect behind WizeAssist, ensuring the platform’s AI features are as powerful as they are 
                  user-friendly—helping coaches and athletes train like never before.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Our Mission Section */}
      <section className="mission-section glass p-5 text-center">
        <h2 className="text-teal mb-4">Our Mission</h2>
        <p className="lead text-white">
          At WizeAssist, our mission is to bridge the gap between athletic potential and performance excellence. 
          We aim to harness the power of artificial intelligence and data analytics to provide actionable insights, 
          personalized training programs, minimizing injury risks and comprehensive performance tracking. Our goal is to support teams, clinics and gyms 
          at every level—whether amateur or professional—in achieving their best, safely and efficiently.
        </p>
      </section>

      {/* Additional Call-to-Action Section */}
      <section className="cta-section text-center py-5">
        <h2 className="text-teal mb-4">Have a Specific Need?</h2>
        <p className="lead text-white mb-4">
          Whether you have a unique requirement or need a tailored solution, we're here to help. Let us know how we can support you in achieving your goals.
        </p>
        <Link 
          to="/contact" 
          className="btn btn-primary btn-lg pulse-cta"
          style={{ 
            padding: '0.75rem 2rem', 
            borderRadius: '8px', 
            backgroundColor: 'var(--color-teal)', 
            border: 'none' 
          }}
          aria-label="Talk to Us"
        >
          Talk to Us
        </Link>
      </section>
    </main>
  );
}

export default AboutUs;
